import React from 'react';
import { Box } from '@qga/roo-ui/components';
import PropTypes from 'prop-types';

import ConditionsMarkdown from '@/components/ConditionsMarkdown';
import Heading from '@/components/Heading';
import Modal from '@/components/Modal';
import Text from '@/components/Text';

/**
 * @typedef {Object} TermsAndConditionModalProps
 * @property {function} close - Function to close the modal. Required.
 * @property {string} content - The main content text of the modal. Required.
 * @property {string} [subtitle] - Optional subtitle text.
 * @property {string} [title] - Optional title text.
 */

/**
 * @param {TermsAndConditionModalProps} props
 */
const TermsAndConditionModal = ({
  close,
  content,
  subtitle,
  title = 'Offer terms & conditions',
}) => (
  <Modal size="lg" onClose={() => close()}>
    <Modal.Header>{title}</Modal.Header>
    <Modal.Body>
      {subtitle && <Heading.h4 fontSize="md">{subtitle}</Heading.h4>}
      <Box color="text.body" mt="2">
        <Text>
          <ConditionsMarkdown markdown={content} paragraphFontSize="sm" />
        </Text>
      </Box>
    </Modal.Body>
  </Modal>
);

TermsAndConditionModal.propTypes = {
  close: PropTypes.func.isRequired,
  content: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  title: PropTypes.string,
};

export default TermsAndConditionModal;
